import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private readonly http: HttpClient,
    private readonly storageService: StorageService
  ) {}

  login(payload: any): Observable<any> {
    let url = environment.BASE_URL + '/v1/auth/login';
    return this.http.post(url, payload);
  }

  getSelfDetails(): Observable<any> {
    let url = environment.BASE_URL + '/v1/user/self';
    return this.http.get(url);
  }


  isAdmin() {
    let userData: any = localStorage.getItem('selfDetails');
    userData = JSON.parse(userData);
    if (userData?.enrollmentType == 'Admin') {
      return true;
    }
    return false;
  }

  isRootUser() {
    let userData: any = localStorage.getItem('selfDetails');
    userData = JSON.parse(userData);
    let isPrimary: boolean = false;
    if (userData?.enrollmentType == 'Admin') {
      return false;
    }
    userData.assignedTo.map((ele: any) => {
      isPrimary = ele.primary;
      // }
    });
    if (isPrimary) {
      return true;
    }
    return false;
  }

  getOrganizationStructureById(id: any) {
    let url = environment.BASE_URL + '/v1/company-structure';
    if (id) {
      url += '/' + id;
    }
    return this.http.get(url);
  }

  getLoginOtp(payload: any) {
    let url = environment.BASE_URL + '/v1/auth/generate-login-otp';
    return this.http.post(url, payload)
  }

  loginUsingOtp(payload: any) {
    let url = environment.BASE_URL + '/v1/auth/token-using-otp';
    return this.http.post(url, payload)
  }

  getRegisterOtp(payload: any) {
    let url = environment.BASE_URL + '/v1/auth/generate-verify-otp';
    return this.http.post(url, payload)
  }

  submitRegistrationOtp(payload: any) {
    let url = environment.BASE_URL + '/v1/auth/verify-otp';
    return this.http.post(url, payload)
  }

  getRefreshToken(refreshToken: string) {
    let url = environment.BASE_URL + '/v1/auth/refresh-token';
    return this.http.post(url, {refreshToken})
  }

  needsTokenRefresh(): boolean {
    const refreshAt = this.storageService.getDataFromLocalStorage(StorageKeys.REFRESH_AT);
    if (!refreshAt) return false;
    return Date.now() >= Number(refreshAt);
  }

  updateSessionTimes() {
    const currentTime = Date.now();
    const nextRefresh = currentTime + 7.5 * 60 * 60 * 1000;
    this.storageService.setDataToLocalStorage(StorageKeys.REFRESH_AT, nextRefresh);
  }

}
